import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import "./CoupanPage.css";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { maintainCartdata } from "../../home/redux/actions";
import { useTranslation } from "react-i18next";
import no_offers from "../../../assets/no_offers.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import close_cross from "../../../assets/close_cross.svg";
import { getRequestcall } from "../../comman/util/getRequest";
import { APPLY_COUPONCODE, STOREOFFER_LIST } from "../../constants/apiurl";

function CoupanPage(props) {
  const [couponlist, setCouponlist] = useState([]);
  const [nocoupon, setNocoupon] = useState(false);
  const { t } = useTranslation();

  const showOfferlist = async () => {
    let geturl = STOREOFFER_LIST+`?store_id=${props?.cartdata[0]?.store_id}`;
    let getStoreofferlistapiResponse = await getRequestcall(
      geturl,
      props?.access_token
    );
    if (getStoreofferlistapiResponse?.status === 200) {
      let getlist = await getStoreofferlistapiResponse.json();
      if (getlist?.data?.length === 0) {
        setNocoupon(true);
        setCouponlist([]);
      } else {
        setNocoupon(false);
        setCouponlist(getlist?.data);
      }
    } else {
    }
  };

  const applyCouponcode = async (item) => {
    if (item?.coupon_code !== props?.amount?.coupon_code) {
      if (
        item?.min_order_amount != null &&
        props?.amount?.total_amount >= item?.min_order_amount
      ) {
        let geturl = APPLY_COUPONCODE + `?coupon_code=${item?.coupon_code}`;
        let getapplycouponResponse = await getRequestcall(
          geturl,
          props?.access_token
        );
        if (getapplycouponResponse?.status === 200) {
          let coupon_price = await getapplycouponResponse.json();
          let amount = {
            ...props.amount,
            discount:
              item?.type === "percentage"
                ? coupon_price?.data?.offer_price
                : Number(coupon_price?.data?.offer_type_value),
            coupon_code: coupon_price?.data?.coupon_code,
            offer_id: item?.id,
          };
          props.maintainCartdata(props.cartdata, amount);
          props.setShowcoupon(false);
        } else if (getapplycouponResponse.status === 500) {
          toast.error(t("pages.internal"));
        }
      } else {
        toast.error(t("pages.coupan.cant_apply"));
      }
    } else {
      toast.error(t("pages.coupan.already"));
    }
  };

  const couponClose = () => {
    props.setShowcoupon(false);
  };

  return (
    <Modal
      className="coupan_popup_modal"
      onShow={() => showOfferlist()}
      show={props.showcoupon}
      centered
    >
      <Modal.Body>
        <img
          src={close_cross}
          className={"close-icon"}
          alt={"close"}
          style={{ right: "-3px", top: "-5px", background: "white" }}
          onClick={() => couponClose()}
        />
        <div className="text-center d-flex flex-column align-center">
          <h5 className="header-title header_border">
            {t("pages.coupan.title")}
          </h5>
        </div>
        <div className="coupan_div" style={{ display: nocoupon ? "grid" : "" }}>
          {nocoupon ? (
            <div className="no_product">
              <LazyLoadImage alt="" src={no_offers} />
              <h5>{t("pages.No coupon found")}</h5>
            </div>
          ) : (
            couponlist.map((item, index) => (
              <div kay={index.toString()} className={"coupanList"}>
                <h5>
                  {props?.language === "Tr" ? item?.title_in_tr : item?.title}
                </h5>
                <p>
                  {item?.type === "percentage" ? (
                    <strong>
                      {t("pages.coupan.get")} {item?.percentage} %{" "}
                      {t("pages.coupan.off")}{" "}
                    </strong>
                  ) : (
                    <strong>
                      {" "}
                      {t("pages.coupan.get")} {item?.flat_discount}
                      {process.env.REACT_APP_CURRENCY_SYMBOL}{" "}
                      {t("pages.coupan.off")}
                    </strong>
                  )}
                  <br />
                  {t("pages.coupan.minimum")} {item.min_order_amount}{" "}
                  {process.env.REACT_APP_CURRENCY_SYMBOL}
                </p>
                <div className="w-100 d-flex align-center justify-space-between mb-2">
                  <h5 className="coupan-code">{item?.coupon_code}</h5>
                  <button
                    className="apply-btn"
                    onClick={() => applyCouponcode(item)}
                  >
                    {t("pages.coupan.submit")}
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login?.access_token,
  cartdata: state?.home?.cartdata,
  amount: state?.home?.amount,
  language: state?.languageState?.language,
});

export default connect(mapStateToProps, { maintainCartdata })(CoupanPage);
